// Copyright (c) 2024, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

declare global {
  interface Window {
    config: {
      AUTH_SIGN_IN_REDIRECT_URL: string;
      AUTH_SIGN_OUT_REDIRECT_URL: string;
      ASGARDEO_CLIENT_ID: string;
      ASGARDEO_BASE_URL: string;
      BACKEND_BASE_URL: string;
      DEPLOYED_ENVIRONMENT: string;
      HR_ROLE: string;
      MARKETING_ROLE: string;
      EMPLOYEE_ROLE: string;
      ADMIN_ROLE: string;
    };
  }
}

// Set the application name
export const APP_NAME: string = "Applicant Tracking System";

// Send the request to get the user privileges from the backend when loading app
export const InitialUserPrivilegeRequest = false;

// Send the request to get the user info from the backend when loading app
export const InitialUserInfoRequest = false;

// Need to dynamically load from .env reading references and will handle.
export const asgardeoConfig = {
  afterSignInUrl: window.config.AUTH_SIGN_IN_REDIRECT_URL,
  afterSignOutUrl: window.config.AUTH_SIGN_OUT_REDIRECT_URL,
  clientId: window.config.ASGARDEO_CLIENT_ID,
  baseUrl: window.config.ASGARDEO_BASE_URL,
  scopes: ["openid", "email", "groups", "roles"],
};

export const ServiceBaseUrl = window.config.BACKEND_BASE_URL;

export const DeployedEnvironment = window.config?.DEPLOYED_ENVIRONMENT ?? null;

export const hrRole = window.config?.HR_ROLE ?? null;

export const marketingRole = window.config?.MARKETING_ROLE ?? null;

export const employeeRole = window.config?.EMPLOYEE_ROLE ?? null;

export const adminRole = window.config?.ADMIN_ROLE ?? null;

export const AppConfig = {
  serviceUrls: {
    userPrivileges: ServiceBaseUrl + "/user-privileges",
    userData: ServiceBaseUrl + "/user-info",
    jobDescriptions: ServiceBaseUrl + "/job-descriptions",
    jobRequisition: ServiceBaseUrl + "/job-requisitions",
    approvedJobRequisitions: ServiceBaseUrl + "/job-requisitions/approved",
    vacancies: ServiceBaseUrl + "/vacancies",
    candidates: ServiceBaseUrl + "/candidates",
    employees: ServiceBaseUrl + "/employees",
    careerFunctions: ServiceBaseUrl + "/career-functions",
    orgDetails: ServiceBaseUrl + "/org-details",
    companies: ServiceBaseUrl + "/companies",
    jdGoogleDoc: ServiceBaseUrl + "/job-descriptions/documents",
    interview: ServiceBaseUrl + "/interviews",
    recruiter: ServiceBaseUrl + "/recruiters",
    feedbackReminder: ServiceBaseUrl + "/feedback-reminder",
    appConfig: ServiceBaseUrl + "/app-config",
    offerLetters: ServiceBaseUrl + "/offer-letters",
  },
};
